var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashbaord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 23,
    viewBox: "0 0 29 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1481 3.40625H15.3333C14.8628 3.40625 14.4814 3.78764 14.4814 4.2581V9.79514C14.4814 10.2656 14.8628 10.647 15.3333 10.647H22.1481C22.6186 10.647 23 10.2656 23 9.79514V4.2581C23 3.78764 22.6186 3.40625 22.1481 3.40625Z",
    stroke: "#303030",
    strokeWidth: 1.27778
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0739 13.2031H4.25908C3.78861 13.2031 3.40723 13.5845 3.40723 14.055V19.592C3.40723 20.0625 3.78861 20.4439 4.25908 20.4439H11.0739C11.5444 20.4439 11.9257 20.0625 11.9257 19.592V14.055C11.9257 13.5845 11.5444 13.2031 11.0739 13.2031Z",
    stroke: "#303030",
    strokeWidth: 1.27778
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1481 13.2031H15.3333C14.8628 13.2031 14.4814 13.5845 14.4814 14.055V19.592C14.4814 20.0625 14.8628 20.4439 15.3333 20.4439H22.1481C22.6186 20.4439 23 20.0625 23 19.592V14.055C23 13.5845 22.6186 13.2031 22.1481 13.2031Z",
    stroke: "#303030",
    strokeWidth: 1.27778
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0739 3.40625H4.25908C3.78861 3.40625 3.40723 3.78764 3.40723 4.2581V9.79514C3.40723 10.2656 3.78861 10.647 4.25908 10.647H11.0739C11.5444 10.647 11.9257 10.2656 11.9257 9.79514V4.2581C11.9257 3.78764 11.5444 3.40625 11.0739 3.40625Z",
    stroke: "#303030",
    strokeWidth: 1.27778
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashbaord);
export default __webpack_public_path__ + "static/media/Dashbaord.4add3be0c74a791cc0d21491e24cc4a7.svg";
export { ForwardRef as ReactComponent };